import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Locales loaded dynamically — populated by translate scripts
import ro from "./locales/ro.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import bg from "./locales/bg.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "ro", label: "Română", flag: "🇷🇴" },
  { code: "bg", label: "Български", flag: "🇧🇬" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { ro, en, de, fr, es, bg },
    fallbackLng: "ro",
    supportedLngs: ["ro", "en", "de", "fr", "es", "bg"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "appointiq_lang",
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
